import { IRequest } from '@r1-frontend/shared/types/IRequest';

import { IReplanRequest } from './dto/IReplanRequest';

/**
 * Изменение времени/телефона всех заявок на договоре, одновременно.
 * https://master.api-request.sandbox.d2c.r-one.io/docs/v1#/ManagingConnectionRequest/b08f858bfc0beaaa99ba85bd90a2646c
 */
export const replan = (body: IReplanRequest): IRequest => ({
    uri: '/v1/managing-connection-request/re-plan',
    method: 'POST',
    withAuth: true,
    withProvider: true,
    body: JSON.stringify(body),
});
